import React from 'react';
import { createGlobalStyle } from 'styled-components';
import DesignStore from 'Store/DesignStore';
import fonts from '../Fonts';

interface DynamicStylesProps {
  backgroundColor?: string | null;
  baseColor?: string | null;
  buttonColor?: string | null;
  logoColor?: string | null;
  mainSaleColor?: string | null;
  textColor?: string | null;
}

const DynamicGlobalStyle = createGlobalStyle<DynamicStylesProps>`
  @font-face {
    font-family: 'Geist';
    src: url(${fonts.GeistVariable}) format('truetype');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
  }


  @font-face {
    font-family: 'Instrument Serif';
    src: url(${fonts.InstrumentSerifRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Instrument Serif';
    src: url(${fonts.InstrumentSerifItalic}) format('truetype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Instrument Serif Italic';
    src: url(${fonts.InstrumentSerifItalic}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  :root {
    /* Fonts */
    --font-primary: 'Geist';
    --font-secondary: 'Instrument Serif';
    --font-tertiary: 'Instrument Serif Italic';

    /* Colors - Toujours appliquées pour les composants External */
    /* Utilise des couleurs transparentes par défaut pour éviter le flash noir */
    ${(props) =>
      props.backgroundColor
        ? `--design-background-color: ${props.backgroundColor};`
        : '--design-background-color: transparent;'}
    ${(props) =>
      props.baseColor
        ? `--design-base-color: ${props.baseColor};`
        : '--design-base-color: #000000;'}
    ${(props) =>
      props.buttonColor
        ? `--design-button-color: ${props.buttonColor};`
        : '--design-button-color: transparent;'}
    ${(props) =>
      props.logoColor
        ? `--design-logo-color: ${props.logoColor};`
        : '--design-logo-color: #000000;'}
    ${(props) =>
      props.mainSaleColor
        ? `--design-main-sale-color: ${props.mainSaleColor};`
        : '--design-main-sale-color: transparent;'}
    ${(props) =>
      props.textColor
        ? `--design-text-color: ${props.textColor};`
        : '--design-text-color: transparent;'}
  }

  /* Force l'utilisation de la police primaire partout */
  *, *::before, *::after,
  div, span, p, a, button, input, textarea, select, label, h1, h2, h3, h4, h5, h6 {
    /* font-family: var(--font-primary) !important; */
  }
`;

export const DynamicStylesExternal: React.FC = () => {
  const backgroundColor = DesignStore.useStoreState(
    (state) => state.backgroundColor
  );
  const baseColor = DesignStore.useStoreState((state) => state.baseColor);
  const buttonColor = DesignStore.useStoreState((state) => state.buttonColor);
  const logoColor = DesignStore.useStoreState((state) => state.logoColor);
  const mainSaleColor = DesignStore.useStoreState(
    (state) => state.mainSaleColor
  );
  const textColor = DesignStore.useStoreState((state) => state.textColor);

  return (
    <DynamicGlobalStyle
      backgroundColor={backgroundColor}
      baseColor={baseColor}
      buttonColor={buttonColor}
      logoColor={logoColor}
      mainSaleColor={mainSaleColor}
      textColor={textColor}
    />
  );
};
